import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';
import { submissionsApi } from '../api/submissions';

export function useProblemSubmissions(slug: string) {
  return useQuery({
    queryKey: queryKeys.submissions.byProblem(slug),
    queryFn: () => submissionsApi.getByProblem(slug),
    staleTime: 30_000,
    enabled: !!slug,
  });
}
